import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { BenefitsSection } from '../components/BenefitsSection';
import { ControlSection } from '../components/ControlSection';
import { HowItWorks } from '../components/HowItWorks';
import { TechnologySection } from '../components/TechnologySection';
import { CredibilitySection } from '../components/CredibilitySection';
import { LeadFormSection } from '../components/LeadFormSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { heroVersions } from '../data/heroVersions';
import { useScrollDepth } from '../hooks/useScrollDepth';
import { scrollToId } from '../utils/scroll';
import { track } from '../utils/tracking';

/** Meta ad angle: A = independence, B = AI and follow-up, C = marketing, D = systems and support. */
export type AdVersion = 'A' | 'B' | 'C' | 'D';
interface LandingProps {
  adVersion: AdVersion;
  showStickyMobileCta: boolean;
}
export function Landing({
  adVersion,
  showStickyMobileCta
}: LandingProps) {
  const copy = heroVersions[adVersion];
  useScrollDepth();
  const onFormCta = useCallback((source: string) => {
    if (source.startsWith('hero')) {
      track('hero_cta_click', {
        source
      });
    }
    scrollToId('lead-form');
  }, []);
  return <div className="w-full bg-white pb-[68px] md:pb-0" data-id="element-218" data-mp="l2mbyfzczsmk">
      <Header onFormCta={onFormCta} data-id="element-219" data-mp="gzzh067e5rl5" />

      <main data-id="element-220" data-mp="h115bcdf4akt">
        <Hero copy={copy} onFormCta={onFormCta} data-id="element-221" data-mp="h1amcaghj7ed" />
        <BenefitsSection onFormCta={onFormCta} data-id="element-222" data-mp="c76dtmrkmrb6" />
        <ControlSection onFormCta={onFormCta} data-id="element-223" data-mp="c5v9nlu7rhjj" />
        <HowItWorks data-id="element-224" data-mp="782670kap1my" />
        <TechnologySection onFormCta={onFormCta} data-id="element-225" data-mp="78lk866tr5vp" />
        <CredibilitySection data-id="element-226" data-mp="14p0tq5n9bow8" />
        <LeadFormSection data-id="element-227" data-mp="14pamg0zosa5m" />
        <FAQSection data-id="element-228" data-mp="14qlp1xhebbv5" />
        <FinalCTA onFormCta={onFormCta} data-id="element-229" data-mp="zxsjx8i0m1ij" />
      </main>

      <Footer data-id="element-230" data-mp="zx0qa37zaduw" />

      {showStickyMobileCta && <StickyMobileCTA onFormCta={onFormCta} data-id="element-231" data-mp="1iu15jz9kq3kl" />}
    </div>;
}